import store from "store/store";

const prefix = "@stemify.ai";

export const localStore = window.localStorage;
export const authKey = `${prefix}:auth`;
export const accountKey = `${prefix}:account`;
